import { Optional } from 'utility-types';

export const memoForCallbacks = <
  Params extends Record<string, unknown>,
  Result,
>(
  actualFn: (args: Params) => Result,
  areEqual: (old?: Optional<Params>, cur?: Optional<Params>) => boolean,
): ((args: Params) => Result) => {
  const lastResultLookup: Record<string, Result> = {};
  const lastArgsLookup: Record<string, Params | undefined> = {};

  return (args) => {
    const err = new Error();
    const uniqHash = err.stack || '';
    const lastArgs = lastArgsLookup[uniqHash];

    if (areEqual(lastArgs, args)) {
      return lastResultLookup[uniqHash];
    }
    lastResultLookup[uniqHash] = actualFn(args);
    lastArgsLookup[uniqHash] = args;

    return lastResultLookup[uniqHash];
  };
};
